import { render, staticRenderFns } from "./doctorClinic.vue?vue&type=template&id=700fbe24&scoped=true&"
import script from "./doctorClinic.vue?vue&type=script&lang=js&"
export * from "./doctorClinic.vue?vue&type=script&lang=js&"
import style0 from "./doctorClinic.vue?vue&type=style&index=0&id=700fbe24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700fbe24",
  null
  
)

export default component.exports